import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
    logoUrl = 'assets/img/logos/NHC_stacked_cmyk_blk.png';
    tosAccepted = false;
    constructor(private router: Router) { }

    ngOnInit() {
    }

    toggleTOSAccepted(event) {
        this.tosAccepted = !this.tosAccepted;
    }

    beginQuestionnaire() {
        this.router.navigate(['forms/questionnaire']);
    }
}
